import { defineComponent as _defineComponent } from 'vue'
import orderBy from 'lodash/orderBy';
import { computed } from 'vue';
import { applyPhoneMask } from '@/utils/number';
import { formatSecToTime } from '@/utils/datetime';
import { RealtimeReportServiceGetQueueCallsStateResult } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'QueueCallsTable',
  props: {
    queueCalls: { type: Array, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const computedQueueCalls = computed(() => {
    const sorted = orderBy(
        props.queueCalls,
        [
            (qc) => qc.queueModel.name || '',
            (qc) => qc.callerIdNum || '',
            (qc) => qc.destinationNumber || '',
        ],
        ['asc', 'asc', 'asc'],
    );

    return sorted.map((qc) => ({
        key: qc.uniqueId,
        clientNumber: applyPhoneMask(qc.callerIdNum || ''),
        destinationNumber: applyPhoneMask(qc.destinationNumber || ''),
        queueName: qc.queueModel.name || '',
        wait: formatSecToTime(qc.wait || 0),
    }));
});

const __returned__ = { props, computedQueueCalls }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})